import { Tooltip as KobalteTooltip } from "@kobalte/core/tooltip"
import type { AccentHue } from "@repo/fika-design-system/color"
import { type ParentProps, Show } from "solid-js"
import { tooltipContentRecipe, tooltipTriggerClass } from "./tooltip.css"

type Props = ParentProps & {
  label: string | null
  hue?: AccentHue
}
export function Tooltip(props: Props) {
  return (
    <Show when={props.label} fallback={props.children}>
      <KobalteTooltip
        gutter={4}
        placement="top"
        openDelay={0}
        closeDelay={0}
        skipDelayDuration={0}
      >
        <KobalteTooltip.Trigger class={tooltipTriggerClass}>
          {props.children}
        </KobalteTooltip.Trigger>
        <KobalteTooltip.Portal>
          <KobalteTooltip.Content
            class={tooltipContentRecipe({ hue: props.hue })}
          >
            <p>{props.label}</p>
          </KobalteTooltip.Content>
        </KobalteTooltip.Portal>
      </KobalteTooltip>
    </Show>
  )
}
